import React from 'react';
import Loader from '../common/Loader';
import LoadingError from '../common/LoadingError';
import { UseQueryResult, UseMutationResult } from '@tanstack/react-query';

type QueryResultProps<TData, TError, TVariables> = {
  loadingText?: string;
  errorText?: string;
  result: UseQueryResult<TData, TError> | UseMutationResult<TData, TError, TVariables>;
  children?: (result: UseQueryResult<TData, TError> | UseMutationResult<TData, TError, TVariables>) => React.ReactNode;
};

function QueryResult<TData, TError, TVariables>(props: QueryResultProps<TData, TError, TVariables>) {
  const { result, children, loadingText, errorText } = props;

  if (result.isLoading) {
    return <Loader loadingText={loadingText} />;
  }

  if (result.isError) {
    return <LoadingError errorText={errorText} />;
  }

  return children ? children(result) : null;
}

export default QueryResult;
